import type { ReactNode } from "react";
import React from "react";
import "./styles.scss";

export interface AppContainerProps {
  children: ReactNode;
}

const AppContainer = (props: AppContainerProps) => {
  return <div className="appContainer">{props.children}</div>;
};

export default AppContainer;
